// @ts-nocheck
/* eslint-disable */
export default class ScenePixel {
	/**
	 * Vytvoreni pixelu nad scenou.
	 *
	 * @class ScenePixel
	 * @param  {Number} x Souradnice na ose x
	 * @param  {Number} y Souradnice na ose y
	 */
	constructor(x, y) {
		this._x = typeof x === "number" ? x : 0;
		this._y = typeof y === "number" ? y : 0;
	}

	/**
	 * Nastaveni x souradnice.
	 *
	 * @param  {Number} value
	 */
	set x(value) {
		this._x = value;
	}

	/**
	 * Nastaveni y souradnice.
	 *
	 * @param  {Number} value
	 */
	set y(value) {
		this._y = value
	}

	/**
	 * Ziskani souradnice x.
	 *
	 * @return {Number}
	 */
	get x() {
		return this._x;
	}

	/**
	 * Ziskani souradnice y.
	 *
	 * @return {Number}
	 */
	get y() {
		return this._y;
	}

	/**
	 * Do aktualniho pixelu pricti dalsi pixel.
	 *
	 * @param {ScenePixel} pixel Dalsi pixel
	 * @chainable
	 */
	plus(pixel) {
		this._x += pixel.x;
		this._y += pixel.y;
		return this;
	}

	/**
	 * Do aktualniho pixelu odecti dalsi pixel.
	 *
	 * @param {ScenePixel} pixel Dalsi pixel
	 * @chainable
	 */
	minus(pixel) {
		this._x -= pixel.x;
		this._y -= pixel.y;
		return this;
	}

	/**
	 * Vytvoreni kopie aktualniho pixelu.
	 *
	 * @param {ScenePixel}
	 */
	clone() {
		return new ScenePixel(this._x, this._y);
	}

	/**
	 * Vrátí normu pixelu (vzdálenost k počátku).
	 *
	 * @param {Number}
	 */
	norm() {
		return Math.sqrt(Math.pow(this._x, 2) + Math.pow(this._y, 2));
	}

	/**
	 * Vynásobí pixel konstantou či párem konstant
	 *
	 * @param {Number} sx scale X
	 * @param {Number} [sy=sx] scale Y
	 * @chainable
	 */
	scale(sx, sy?) {
		if (arguments.length < 2) {
			sy = sx;
		}

		this._x *= parseFloat(sx) || 0;
		this._y *= parseFloat(sy) || 0;
		return this;
	}

	/**
	 * Vzdalenst mezi dvema pixely.
	 *
	 * @param {ScenePixel} pixel Dalsi pixel
	 * @param {Number} Vzdalenost v [px]
	 */
	distance(pixel) {
		let dx = this._x - pixel.x;
		let dy = this._y - pixel.y;

		return Math.sqrt(Math.pow(dx, 2) + Math.pow(dy, 2));
	}

	/**
	 * Prevod pixelu na string.
	 *
	 * @return {String}
	 */
	toString() {
		return ("[" + this._x + "," + this._y + "]");
	}
}
